module.exports = __webpack_public_path__ + "img/login500x400.3e225e55.png";